export default __webpack_public_path__ + "static/media/boy-blue.20060732.png";